module.exports = __webpack_public_path__ + "img/icon42.ca87f8c6.png";